import { Directive, Host, HostListener, Input, Optional, Renderer2, SkipSelf } from '@angular/core';
import { ResizableColumnDirective } from './resize-column-width.directive';

@Directive({ selector: '[columnResizeHandle]' })
export class ResizeHandleDirective {
  @Input('columnResizeHandle') columnName!: string;

  private initialMouseX!: number;
  private initialColumnWidth!: number;
  private removeMouseMoveListener!: () => void;
  private removeMouseUpListener!: () => void;
  private readonly MIN_COLUMN_WIDTH = 50;

  constructor(
    private renderer: Renderer2,
    @Host()
    @SkipSelf()
    @Optional()
    private parentResizable: ResizableColumnDirective,
  ) {}

  private get columnElement(): HTMLElement {
    return this.parentResizable.el.nativeElement;
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    this.initialMouseX = event.pageX;
    this.initialColumnWidth = this.columnElement.offsetWidth;
    this.renderer.addClass(this.columnElement, 'resizing');

    this.removeMouseMoveListener = this.renderer.listen('document', 'mousemove', (e: MouseEvent) =>
      this.handleMouseMove(e),
    );
    this.removeMouseUpListener = this.renderer.listen('document', 'mouseup', () => this.handleMouseUp());
  }

  private handleMouseMove(event: MouseEvent): void {
    const dx = event.pageX - this.initialMouseX;
    const newWidth = this.initialColumnWidth + dx;
    if (newWidth > this.MIN_COLUMN_WIDTH) {
      const selector = `
        .uli-list__header-column_${this.columnName},
        .uli-list__column_${this.columnName}
      `;
      document
        .querySelectorAll<HTMLElement>(selector)
        .forEach((el: HTMLElement) => this.renderer.setStyle(el, 'flex', `0 0 ${newWidth}px`));
    }
  }

  private handleMouseUp(): void {
    this.renderer.removeClass(this.columnElement, 'resizing');

    const finalWidth = this.columnElement.offsetWidth;
    ResizableColumnDirective.widths[this.columnName] = finalWidth;

    this.removeMouseMoveListener?.();
    this.removeMouseUpListener?.();
  }
}
